import { DiscardReturnReason } from '../../database/schema.js';
import { QaRejectReason } from './state-machine.js';
// CY-330: a preparation rejected at QA is recorded in Discards like a discarded return, so waste and cost
// reports and the cytotoxic-waste trace include the bag, not only its rest vials.
/** The discard reason that best describes why QA rejected the preparation. */
export function toDiscardReason(reason) {
    switch (reason) {
        case QaRejectReason.enum.LEAKAGE:
            return DiscardReturnReason.enum.SPOILED;
        case QaRejectReason.enum.PARTICLES_DISCOLOURATION:
            return DiscardReturnReason.enum.CONTAMINATION_SUSPECTED;
        case QaRejectReason.enum.WRONG_VOLUME_WEIGHT:
            return DiscardReturnReason.enum.VOLUME_INSUFFICIENT;
        case QaRejectReason.enum.EXPIRED:
            return DiscardReturnReason.enum.STABILITY_CONCERN;
        default:
            // LABEL_ERROR and OTHER: the QA reason itself goes into the note
            return DiscardReturnReason.enum.OTHER;
    }
}
/** The discard note keeps the QA reason, so a reason mapped to OTHER is still traceable. */
export function buildRejectedPreparationNote(reason, note) {
    return [`QA rejected: ${reason}`, note?.trim()].filter(Boolean).join(' - ');
}
//# sourceMappingURL=qa-reject-discard.js.map